import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import AnnouncementBar from "@/components/AnnouncementBar";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import TrustTicker from "@/components/sections/TrustTicker";
import TrustedBy from "@/components/sections/TrustedBy";
import Capabilities from "@/components/sections/Capabilities";
import PaidMedia from "@/components/sections/PaidMedia";
import OwnedMedia from "@/components/sections/OwnedMedia";
import DataCoverage from "@/components/sections/DataCoverage";
import Framework from "@/components/sections/Framework";
import LeadAudit from "@/components/sections/LeadAudit";
import CaseStudies from "@/components/sections/CaseStudies";
import WhyUs from "@/components/sections/WhyUs";
import MediaPress from "@/components/sections/MediaPress";
import Contact from "@/components/sections/Contact";
import { useLocation } from "react-router-dom";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace(/^#/, "");
    const el = document.getElementById(id);
    if (el) {
      requestAnimationFrame(() => el.scrollIntoView({ behavior: "smooth", block: "start" }));
    }
  }, [hash]);
  return (
    <main data-testid="home-page" className="relative">
      <AnnouncementBar />
      <Navbar />
      <Hero />
      <TrustTicker />
      <TrustedBy />
      <Capabilities />
      <PaidMedia />
      <OwnedMedia />
      <DataCoverage />
      <Framework />
      <LeadAudit />
      <CaseStudies />
      <WhyUs />
      <MediaPress />
      <Contact />
      <Footer />
    </main>
  );
}
